import { render, staticRenderFns } from "./ContentPane.vue?vue&type=template&id=39438737&scoped=true"
import script from "./ContentPane.vue?vue&type=script&lang=js"
export * from "./ContentPane.vue?vue&type=script&lang=js"
import style0 from "./ContentPane.vue?vue&type=style&index=0&id=39438737&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39438737",
  null
  
)

export default component.exports